export const isValidPhoneNumberFormat = (phoneNumber: string | undefined) => {
	return phoneNumber !== undefined && isValidNorthAmericanPhoneNumber(phoneNumber);
};

//Checks for variations of US, Canada, or Mexico formats +1 555-555-5555, +52 55-5555-5555, etc.
const isValidNorthAmericanPhoneNumber = (phoneNumber: string) =>
	phoneNumber.match(/^(\+\d{1,2}\s?)?(\d{3}[\s.-]?\d{3}|\d{2}[\s.-]?\d{4})[\s.-]?\d{4}$/) !== null;
